import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Clock, X } from 'lucide-react';
import { api } from '../lib/api';
import { useAuth } from '../lib/auth';
import { useAlertaFaixa } from './alertas/AlertasContexto';

interface Resumo { pendentes: number }

const POLLING_MS = 5 * 60 * 1000;
const KEY_DISMISS = 'trocas_pendentes.alerta.dismiss';

function dismissedHoje(): boolean {
  const v = localStorage.getItem(KEY_DISMISS);
  if (!v) return false;
  return v === new Date().toISOString().slice(0, 10);
}

export function AlertaTrocasPendentesBanner() {
  const navigate = useNavigate();
  const { usuario } = useAuth();
  const [resumo, setResumo] = useState<Resumo | null>(null);
  const [dismissed, setDismissed] = useState(dismissedHoje);

  const podeVer = usuario && ['admin', 'gerente'].includes(usuario.perfil);

  useEffect(() => {
    if (!podeVer) return;
    let cancelado = false;
    async function tick() {
      try {
        const r = await api.get<Resumo>('/api/trocas/pendentes-resumo');
        if (!cancelado) setResumo(r);
      } catch {}
    }
    void tick();
    const id = setInterval(tick, POLLING_MS);
    return () => { cancelado = true; clearInterval(id); };
  }, [podeVer]);

  const fundo = '#f59e0b';
  const borda = '#d97706';
  const texto = '#000';

  const ativo = !!(podeVer && !dismissed && resumo && resumo.pendentes > 0);
  const recolhido = useAlertaFaixa(
    'trocas',
    ativo ? { rotulo: 'Trocas', bg: fundo, borda, qtd: resumo!.pendentes } : null,
  );

  if (!ativo || recolhido || !resumo) return null;

  function fechar() {
    localStorage.setItem(KEY_DISMISS, new Date().toISOString().slice(0, 10));
    setDismissed(true);
  }

  return (
    <div
      style={{
        background: fundo,
        borderLeft: `4px solid ${borda}`,
        color: texto,
        padding: '8px 14px',
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        fontSize: 13,
        cursor: 'pointer',
      }}
      onClick={() => navigate('/trocas?aba=historico&validacao=aguarda')}
    >
      <Clock size={16} />
      <span style={{ fontWeight: 600 }}>Trocas aguardando validacao:</span>
      <span>
        {resumo.pendentes} {resumo.pendentes === 1 ? 'troca' : 'trocas'} pendente{resumo.pendentes === 1 ? '' : 's'}
      </span>
      <span style={{ marginLeft: 'auto', textDecoration: 'underline' }}>Validar</span>
      <button
        type="button"
        onClick={(e) => { e.stopPropagation(); fechar(); }}
        title="Dispensar ate amanha"
        style={{ background: 'transparent', border: 'none', color: texto, cursor: 'pointer', padding: 2 }}
      >
        <X size={14} />
      </button>
    </div>
  );
}
